import { render, staticRenderFns } from "./productionCode.vue?vue&type=template&id=cf2d673e&scoped=true&"
import script from "./productionCode.vue?vue&type=script&lang=js&"
export * from "./productionCode.vue?vue&type=script&lang=js&"
import style0 from "./productionCode.vue?vue&type=style&index=0&id=cf2d673e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2d673e",
  null
  
)

export default component.exports